import { TMessageBarSeverity } from 'types';
import { IValidationToastNotification } from '../../common';
import { MessageBar } from '@repo/ui/components';

interface IErrorNotification extends IValidationToastNotification {
  invalidItems?: string[];
}

const getWarningMessage = (invalidItems: string[]) => (
  <ul>
    {invalidItems.map((item) => {
      return <li key={item}>{item}</li>;
    })}
  </ul>
);

export const ProdDateWarning = ({
  invalidItems,
  severityLevel = TMessageBarSeverity.ERROR,
  onClose,
}: IErrorNotification) => (
  <MessageBar severity={severityLevel} onClose={onClose} dismissible className="max-w-[20rem] w-auto">
    <h4 className="text-lg/[175%]">Validering av produksjonsdato</h4>
    {getWarningMessage(invalidItems)}
  </MessageBar>
);
